import { Component, OnInit, Input } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { DialogService } from '../../../dialog/dialog.service';
import { DialogModalSize } from '../../../dialog/dialog-ref';
import { AIService } from '../../services/ai.service';
import { PopupFormComponent } from '../../../popupform/popupform.component';

@Component({
    selector: 'app-kx-ai-summary',
    templateUrl: './kx-ai-summary.component.html',
    styleUrls: ['./kx-ai-summary.component.scss'],
    standalone: false
})
export class KxAISummaryComponent implements OnInit {
  @Input()
  set config(value: any) {
    this._config = value;
    this.reinitialize();     // run your init logic here
  }
  public data:any = {editingAvailable:false,isAvailable:false,gridConfig:{}};
  constructor(
    public rolePermissionService:RolePermissionService,
    public baseService:BaseService,
    public aiService:AIService,
    public alertService:AlertsService,
    public dialogService: DialogService,
    public loader:LoaderService,
  ) {    
  
   
  }
  private _config!: any;

  get config() { return this._config; }

  ngOnInit() {
    this.reinitialize();
  }


  reinitialize() {
    console.log(this.config)
    this.aiService.initAiSummary(this.config,this.data)
  }

  
  openModel(){
    if (this.config.showPopup) {
      this.dialogService.open(PopupFormComponent, this.config.showPopup).afterClosed.subscribe(data => {
        //console.log('data', data)
        if (data && data.items && Array.isArray(data.items) && data.items.length > 0) {
          let encounterIds = data.items.map((ele) => ele.encounter_id)
          let str = encounterIds.join('#')
          let filter = this.config.filter;
          filter = filter.replace(
            /encounter_id:[^,]*/,
            `encounter_id:${str}`
          );
          this.config.filter = filter;
          this.config.selectedDatas=data.items
          //speciality
          const sessionData = JSON.parse(sessionStorage.getItem('currentData') || '{}');
          let currentDoctorSpeciality=sessionData.currentTreatingDoctorSpeciality;
          if (currentDoctorSpeciality) {
            if (this.config.filter) {
              this.config.filter += `,current_speciality:${currentDoctorSpeciality}`
            }
          }

          // setTimeout(() => {
            this.showSummary()
          // })
        }
        else { }
      }, err => {
        console.log('err', err)
      })
    }
    else {
      this.showSummary()
    }
  }

  showSummary() {
        let popObj = {
          data: {"config":this.config,"aiData":this.data},
          title: '',
          size: DialogModalSize.Lg
      };
      this.config.popupModel = this.dialogService.openWithSelector(this.baseService,"app-kx-ai-model", popObj);
      this.config.popupModel.dialogComponentRef.instance.getData.subscribe((data)=>{
          if(data.type == "componentRef"){
            data.obj.instance.getData.subscribe((data)=>{
              if(data.type == "prompt_config"){
                this.data.gridConfig.prompt_config = data.obj;
              }            
            });
          }
      });
      this.config.popupModel["dialogRef"].afterClosed.subscribe(response => {
        if(response){
               
        }
        delete this.config.popupModel;
    });
  }


}
